const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';
export async function searchRecalls(brand, code, q) {
    const params = new URLSearchParams();
    if (brand)
        params.append('brand', brand);
    if (code)
        params.append('code', code);
    if (q)
        params.append('q', q);
    const response = await fetch(`${API_BASE_URL}/search?${params.toString()}`);
    if (!response.ok) {
        // Try to parse JSON error, but handle cases where response is empty
        try {
            const errorData = (await response.json());
            throw new Error(errorData.error.message);
        }
        catch (jsonError) {
            // If JSON parsing fails, throw a generic error with status
            throw new Error(`API request failed with status ${response.status}. Make sure the worker is running (cd apps/worker && npm run dev)`);
        }
    }
    return (await response.json());
}
export async function checkHealth() {
    const response = await fetch(`${API_BASE_URL}/health`);
    return await response.json();
}
